<template>
<div class="user-info">
  <v-icon
    class="ma-2 mt-1"
    color="primary"
  >{{ icon }}</v-icon>
  <span class="text-subtitle-3">{{ title }}</span>

    <slot name="default"></slot>

</div>
</template>

<script>
export default {
  name: "InfoSection",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>
